import * as React from 'react';
import {FieldDisplay} from 'src/inputs/FieldInput/FieldDisplay';
import type {FullFieldFragment} from '@transactions/graphql';

type Props = {
  fields: FullFieldFragment[];
  fieldValues: Record<string, string>;
};

export const MultiFieldDisplay = (props: Props) => {
  const {fields, fieldValues} = props;

  const entries = Object.entries(fieldValues).filter(
    ([_, value]) => value != null && value !== '',
  );

  if (entries.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-row flex-wrap gap-1">
      {entries.map(([fieldId, value]) => {
        const field = fields.find((d) => d._id === fieldId);
        const name = field?.name || fieldId;
        return (
          <FieldDisplay key={fieldId} fieldName={name} value={value} />
        );
      })}
    </div>
  );
};
